import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import AuthWrapper from "../../auth/AuthWrapper";
import { noteToClient, UserPublicNotesResponse } from "../../../shared/types";
import { PublicPage } from "../../components/PublicPage";
import { PublicEditor } from "../../components/PublicEditor";
import logger from "../../utils/logger";
import { useApiClient } from "../../api/client";

export default function AllSharedPage() {
  const router = useRouter();
  const userId = (Array.isArray(router.query.userId) ? router.query.userId[0] : router.query.userId) ?? "";
  const [result, setResult] = useState<UserPublicNotesResponse | null>(null);

  const apiClient = useApiClient();

  useEffect(() => {
    if (result || !userId) return;
    apiClient.users.getPublicNotes(userId).then((response) => {
      setResult(response);
    });
  }, [userId, apiClient, result]);

  const notes = result?.data?.notes.map(noteToClient);
  const linkedNotePreviews = result?.data?.linkedNotePreviews || [];
  const error = result?.error;

  useEffect(() => {
    if (!error) return;
    logger.warn("Error loading public notes", { error });
  }, [error]);

  return (
    <AuthWrapper>
      <PublicPage>
        {error ? (
          <div>There was an error loading public notes. Please try again later.</div>
        ) : result === null ? (
          <div>Loading...</div>
        ) : !notes || notes.length === 0 ? (
          <div>No public notes</div>
        ) : (
          <PublicEditor publicNotes={notes} linkedPrivatePreviews={linkedNotePreviews} />
        )}
      </PublicPage>
    </AuthWrapper>
  );
}
